import { START_BET, ASK_QUESTION, DO_ANSWER, RECEIVE_QUESTIONS, SAVE_QUESTION, SAVED_QUESTION, DELETE_QUESTION, DELETED_QUESTION } from './actions'
import Status from './status'
import { RECEIVE_ANSWERS } from '../answers/actions';
import { BET_STARTED, QUESTION_ASKED } from '../questionGame/actions';
import { selectAnswersByQuestion } from '../answers'
import { normalize } from '../../utils/normalize'

export const  questions = (state = {}, action) => {
    switch (action.type) {
        case START_BET:
            return {
                ...state,
                [action.question.id]: {
                    ...state[action.question.id],
                    ...action.question,
                    status: Status.WAITING_BET_ASKED
                }
            }
        
        case BET_STARTED:
            return {
                ...state,
                [action.question.id]: {
                    ...state[action.question.id],
                    ...action.question,
                    status: Status.WAITING_BETS
                }
            }

        case ASK_QUESTION:
        case QUESTION_ASKED:
            return {
                ...state,
                [action.question.id]: {
                    ...state[action.question.id],
                    ...action.question,
                    status: Status.WAITING_ASKED
                }
            }

        case DO_ANSWER:
            return {
                ...state,
                [action.question.id]: {
                    ...state[action.question.id],
                    answer: action.answer,
                    status: Status.ANSWERED
                }
            }

        case RECEIVE_QUESTIONS:
            return Object.assign({}, state, normalize(state, action.questions))

        case SAVE_QUESTION:
            return Object.assign({}, state, normalize(state, [{ ...action.question, updating: true }]))

        case SAVED_QUESTION:
            const newState = Object.assign({}, state, normalize(state, [{ ...action.question, updating: false }]))
            const { prevId } = action
            if (prevId && prevId !== action.question.id && newState[prevId])
                delete newState[prevId]
            return newState

        case DELETE_QUESTION:
            return Object.assign({}, state, normalize(state, [{ ...action.question, deleting: true }]))

        case DELETED_QUESTION:
            const newDeleteState = { ...state }
            delete newDeleteState[action.question.id]
            return newDeleteState

        case RECEIVE_ANSWERS:
            const questionIds = action.answers.map(a => a.question_id)
            const counts = {}
            questionIds.forEach(id => counts[id] = (counts[id] || 0) + 1)
            const questions = Object.keys(counts).map(question_id => ({ ...state[question_id], answersCount: counts[question_id] }))
            return Object.assign({}, state, normalize(state, questions))


        default:
            return state
    }
}


export const getQuestionStatus = (question_id, game_id, state) => {
    const userAnswer = state.userAnswer[game_id+" "+question_id];
    const question_game = state.question_game[game_id+" "+question_id];
    if (!question_id || !game_id || !question_game)
        return null
    if (userAnswer && userAnswer.hasOwnProperty('gain'))
        return Status.COMPLETED
    if (question_game.end_ask_date)
        return Status.ASKED
    if (userAnswer && userAnswer.answer)
        return Status.ANSWERED
    if (question_game.ask_date)
        return Status.WAITING_ANSWERS
    if (question_game.end_bet_date)
        return Status.TO_ASK
    if (userAnswer && userAnswer.bet)
        return Status.TO_ASK
    if (question_game.bet_date)
        return Status.WAITING_BETS
    return Status.TO_BET
}

export const selectQuestion = (state, id) => {
    if (id === 'new')
        return { answers: [] }
    const question = state.questions[id]
    return question
}

export const selectQuestions = (state, ids) => ids.map(id => state.questions[id]).filter(q => !!q)

// restituisce la lista di questions_game relativi a quel match
export const selectQuestionsGameByMatch = (state, game_id) => {
    if (!state.question_game)
        return []
    const question_game =  Object.keys(state.question_game)
        .map(questionAndMatch_id => state.question_game[questionAndMatch_id])
        .filter(q => q && q.game_id === game_id)
        .map(q=>({...q, question : state.questions[q.question_id]}))
        .sort(function (a, b) {
            return a.position - b.position;
         })
    return question_game;
}

//restituisce una lista di domande (ognuna delle quali contiene tutte le info delle domande
export const selectQuestionsByMatch = (state, game_id) => {
    return selectQuestionsGameByMatch(state,game_id)
        .map(q=> state.questions[q.question_id]).filter(q => !!q);
}

export const selectAvailableQuestion = (state, game_id) =>{
    if (!state.questions)
        return []
    const thisQuestion = selectQuestionsByMatch(state,game_id);
    const keys = Object.keys(state.questions);
    var selectedQuestions = [];
    for (var i = 0; i < keys.length; i ++){
        var isToBeAdded = true;
        for (var j = 0; j < thisQuestion.length; j ++)
            if (thisQuestion[j].id === keys[i])  isToBeAdded = false; 
        if (isToBeAdded) selectedQuestions = [...selectedQuestions, state.questions[keys[i]]]
    }
    return selectedQuestions;

}

export const selectAnswersCount = (state, question_id) => {
    return selectAnswersByQuestion(state, question_id).length ||
        (state.questions[question_id] && state.questions[question_id].answersCount) ||
        0
}

export const selectSubAnswersCount = (state, question_id) => {
    const totalAnswers = selectAnswersByQuestion(state, question_id);
    var subAnswers = 0;
    for (var i = 0; i < totalAnswers.length; i++){
       if (totalAnswers[i].id !== totalAnswers[i].refer_to)
        subAnswers++;
    }
    return subAnswers;
}

export const selectQuestionsBySearch = (state, searchText) => {
    const lowerCaseText = searchText.toLowerCase()
    return selectQuestions(state, Object.keys(state.questions))
        .filter(q => q.topic.toLowerCase().indexOf(lowerCaseText) !== -1 ||
            q.text.toLowerCase().indexOf(lowerCaseText) !== -1)
}


// WEBPACK FOOTER //
// ./src/reducers/questions/index.js